import { type RootState } from '../../stores/redux';

export const getIsChatOpen = (state: RootState) => state.uiState.isChatOpen;

export const getActiveUserAccordionId = (state: RootState) =>
  state.uiState.activeUserAccordion;

export const getActiveInCallProviderPanelTabs = (state: RootState) =>
  state.uiState.activeInCallProviderPanelTabs;

export const getActiveWaitingRoomProviderPanelTabs = (state: RootState) =>
  state.uiState.activeWaitingRoomProviderPanelTabs;

export const getIsPictureInPictureStarted = (state: RootState) =>
  state.uiState.isPictureInPictureStarted;

export const getIsCallMenuOpen = (state: RootState) =>
  state.uiState.isCallMenuOpen ?? false;

export const getIsSelfPreviewExpanded = (state: RootState) =>
  state.uiState.isSelfPreviewExpanded ?? false;

export const getIsAnimationDisabled = (state: RootState) =>
  state.uiState.isAnimationDisabled ?? false;

export const getScrollTag = (state: RootState) => state.uiState.scrollTag;

export const getHasSeenAppsPopover = (state: RootState) =>
  state.uiState.hasSeenAppsPopover;
